// src/components/CheckoutPixPagarme.js
"use client"
import { useEffect, useState } from "react"
import axios from "axios"
import { motion } from "framer-motion"
import { Copy, AlertCircle, Clock, CheckCircle } from "lucide-react"
import "../styles/checkout.css"

const API = process.env.REACT_APP_API_URL || "https://api.ticketdovaqueiro.com/api"

export default function CheckoutPixPagarme({
  pedidoId, total, nomeVaqueiro, email, cpfCnpj, phone, eventoid, nomeEvento, onSuccess,
}) {
  const [qrUrl, setQrUrl] = useState("")
  const [brcode, setBrcode] = useState("")
  const [erro, setErro] = useState("")
  const [expiraEm, setExpiraEm] = useState(null)
  const [contador, setContador] = useState("")
  const [copiado, setCopiado] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const metodoAtual = "pix"
    if (sessionStorage.getItem("metodoSelecionado") !== metodoAtual) return

    const gerarPix = async () => {
      setLoading(true)
      try {
        setErro("")
        let usuarioLogado = null
        try { usuarioLogado = JSON.parse(localStorage.getItem("user")) } catch {}

        const resp = await axios.post(`${API}/pagamento/pagarme/pix`, {
          pedidoId,
          totalPedido: Number(total),
          nomeVaqueiro,
          email: email || usuarioLogado?.email || "",
          cpfCnpj: cpfCnpj || usuarioLogado?.cpf || "",
          phone: phone || usuarioLogado?.whatsapp || "",
          descricao: `Evento ${nomeEvento} (${eventoid})`,
        })

        const d = resp?.data || {}
        setQrUrl(d.qrCodeUrl || "")
        setBrcode(d.brcode || "")
        const exp = d.expiracao ? new Date(d.expiracao) : null
        setExpiraEm(exp && !isNaN(exp.getTime()) ? exp : null)
        onSuccess && onSuccess(d)
      } catch (e) {
        const detail = e?.response?.data?.detail || e.message || "Falha ao gerar Pix Pagar.me."
        setErro(detail)
      } finally {
        setLoading(false)
      }
    }

    gerarPix()
  }, [API, pedidoId, total, nomeVaqueiro, email, cpfCnpj, phone, eventoid, nomeEvento, onSuccess])

  useEffect(() => {
    if (!expiraEm) return
    const interval = setInterval(() => {
      const diff = expiraEm - new Date()
      if (diff <= 0) { setContador("Expirado"); clearInterval(interval) }
      else {
        const m = Math.floor(diff/60000), s = Math.floor((diff%60000)/1000)
        setContador(`${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`)
      }
    }, 1000)
    return () => clearInterval(interval)
  }, [expiraEm])

  const copiarCodigo = () => {
    if (!brcode) return
    navigator.clipboard.writeText(brcode)
    setCopiado(true)
    setTimeout(() => setCopiado(false), 2000)
  }

  if (loading) return (
    <div className="pix-loading"><div className="loading-spinner"></div><p>Gerando QR Code.</p></div>
  )

  if (erro) return (
    <div className="pix-erro"><AlertCircle size={24} /><p>{erro}</p></div>
  )

  return (
    <motion.div initial={{opacity:0, y:20}} animate={{opacity:1, y:0}} transition={{duration:0.5}} className="pix-container">
      <h3>Pagamento via Pix (Pagar.me)</h3>

      {qrUrl ? (
        <>
          <p>Escaneie o QR Code abaixo ou copie o código:</p>
          <motion.img
            initial={{ scale: .8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: .5, delay: .2 }}
            src={qrUrl}
            alt="QR Code Pix"
            className="qr-image"
          />
        </>
      ) : (
        <p>Copie o código abaixo para pagar no seu app do banco.</p>
      )}

      <div className="pix-codigo">
        <textarea readOnly value={brcode} />
        <button onClick={copiarCodigo} className="copiar-btn">
          {copiado ? <CheckCircle size={18}/> : <Copy size={18}/>} {copiado ? "Copiado!" : "Copiar"}
        </button>
      </div>

      {expiraEm && (
        <div className="pix-expira"><Clock size={16} /><span>Expira em: {contador}</span></div>
      )}
    </motion.div>
  )
}
